import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class OrganisationSettingsGlobalBonValuesComponent extends Component {
  @service organisation;
  @service betaToggle;

  @tracked showPpwSlideover = false;
  @tracked showInvestmentConfidenceSlideover = false;
  @tracked showReturnConfidenceSlideover = false;
  @tracked showClvSlideover = false;
  @tracked showHorizonSlideover = false;

  @action
  togglePpwSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showPpwSlideover = flag;
    else this.showPpwSlideover = !this.showPpwSlideover;
  }

  @action
  toggleClvSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showClvSlideover = flag;
    else this.showClvSlideover = !this.showClvSlideover;
  }

  @action
  toggleInvestmentConfidenceSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showInvestmentConfidenceSlideover = flag;
    else
      this.showInvestmentConfidenceSlideover =
        !this.showInvestmentConfidenceSlideover;
  }

  @action
  toggleReturnConfidenceSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showReturnConfidenceSlideover = flag;
    else
      this.showReturnConfidenceSlideover = !this.showReturnConfidenceSlideover;
  }

  @action
  toggleHorizonSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showHorizonSlideover = flag;
    else this.showHorizonSlideover = !this.showHorizonSlideover;
  }
  get lowConfidence() {
    return this.organisation.investmentConfidenceOptions.filter(
      (item) => item.label === 'Low',
    )[0].value;
  }

  get mediumConfidence() {
    return this.organisation.investmentConfidenceOptions.filter(
      (item) => item.label === 'Medium',
    )[0].value;
  }

  get highConfidence() {
    return this.organisation.investmentConfidenceOptions.filter(
      (item) => item.label === 'High',
    )[0].value;
  }

  get returnsLowConfidence() {
    return this.organisation.returnConfidenceOptions.filter(
      (item) => item.label === 'Low',
    )[0].value;
  }

  get returnsMediumConfidence() {
    return this.organisation.returnConfidenceOptions.filter(
      (item) => item.label === 'Medium',
    )[0].value;
  }

  get returnsHighConfidence() {
    return this.organisation.returnConfidenceOptions.filter(
      (item) => item.label === 'High',
    )[0].value;
  }
}
